import React from 'react'
import { observer } from 'mobx-react'
import { GeoJSON } from 'react-leaflet'

const OptionalGeoJSON = ({ geoJSON, className, finalLine, color, transparency }) => (
  geoJSON && (geoJSON.coordinates[1] || !finalLine)
    ? (
      <GeoJSON
        style={() => ({ color, fill: color })}
        key={JSON.stringify(geoJSON)}
        data={geoJSON}
        className={className}
        fillOpacity={`${transparency}%`}
      />
      )
    : null
)

export default observer(OptionalGeoJSON)
